/* istanbul ignore file */
import React from 'react';
import { DropDownFilterProps, DropDownFilter } from 'framework/list';
import EmployeeWorkingStatusDropdown from 'domain/people/employee/shared/input/EmployeeWorkingStatusDropdown';

const EmployeeWorkingStatusFilter = ({
  excluded,
  source,
  ...props
}: Omit<DropDownFilterProps, 'children'> & { excluded?: string[] }) => {
  return (
    <DropDownFilter source={source} {...props}>
      <EmployeeWorkingStatusDropdown excluded={excluded} source={source} />
    </DropDownFilter>
  );
};

export default EmployeeWorkingStatusFilter;
